// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto';
import Vue from 'vue';
import Vuex from 'vuex';

import App from './app';
import router from './routes';
import storeOption from './vuex/store';
import Validator from './config/customValidate';
import VeeValidate from 'vee-validate'
import zh_CN from 'vee-validate/dist/locale/zh_CN'
import Veeconfig from './config/veeConfig';
import dictionary from './config/dictionary';
import dict from './config/dict';
import vmodal from 'vue-js-modal'  //弹框组件
// import VueInstant from 'vue-instant';
import VueInstant from './components/middleware/vueInstant.js';
import $http from './util/http';
import fiterTool from './util/filter'
Vue.use(VueInstant);
Vue.use(vmodal);
Vue.use(Vuex);
for (let key in fiterTool){
  Vue.filter( key, fiterTool[key]);
}
Vue.prototype.$http = $http;
// 验证通用配置
Vue.use(VeeValidate, Veeconfig);
Validator.addLocale(zh_CN);
Validator.updateDictionary(dictionary);
Validator.updateDictionary(dict);
const validator = new Validator();
validator.setLocale('zh_CN');
// import 'babel-polyfill';

import 'vue-instant/dist/vue-instant.css'
import "assets/css/common/common.scss";
import "assets/css/common/instant.scss";

router.afterEach(route => {
  if(route.meta.title){
     document.title = route.meta.title;
  }
  store.commit('getActive',route );
});
// 创建一个 store 对象用于管理应用状态
const store = new Vuex.Store(storeOption);

window.appVue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});




// WEBPACK FOOTER //
// ./src/main.js